<template>
  <div class="char-counter-textarea">
    <!-- `grouped` conserve la structure .input-group de Bootstrap : le textarea et
         le bouton du slot restent enfants directs du groupe, le compteur vient en
         dessous. Sans `grouped`, le textarea est rendu seul (modales Bulma). -->
    <div :class="{'input-group': grouped}">
      <textarea
          ref="textarea"
          class="form-control-counted"
          :class="[textareaClass, {'over-limit': over_limit}]"
          :id="inputId"
          :placeholder="placeholder"
          :readonly="readonly"
          :rows="rows"
          :style="{resize: resize}"
          :value="value"
          @input="$emit('input', $event.target.value)"
      ></textarea>
      <slot name="append"></slot>
    </div>

    <div class="counter-line" :class="over_limit ? 'counter-over' : 'counter-under'">
      <span class="counter-value">{{ formatted_count }}/{{ formatted_max }}</span>
      <span v-if="over_limit" class="counter-error">
        Limite de {{ formatted_max }} caractères dépassée
      </span>
    </div>
  </div>
</template>

<script>
import tools from "@/tools.js";
import utils from "@/utils.js";

export default {
  name: "CharCounterTextarea",
  props: {
    value: {
      type: String,
      default: ""
    },
    max: {
      type: Number,
      default: tools.DEFAULT_NBR_CHAR_MAX
    },
    rows: {
      type: [Number, String],
      default: 8
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: ""
    },
    // 'form-control' côté MHR (Bootstrap), 'textarea' côté établissement (Bulma)
    textareaClass: {
      type: String,
      default: "form-control"
    },
    grouped: {
      type: Boolean,
      default: false
    },
    resize: {
      type: String,
      default: "both"
    }
  },
  computed: {
    char_count() {
      return tools.char_count(this.value);
    },
    over_limit() {
      return tools.is_over_limit(this.value, this.max);
    },
    formatted_count() {
      return this.char_count.toLocaleString("fr-FR");
    },
    formatted_max() {
      return this.max.toLocaleString("fr-FR");
    }
  },
  watch: {
    over_limit(newV, oldV) {
      // Flash rouge au franchissement de la limite, la bordure rouge reste
      // ensuite tant que le texte est trop long.
      if (newV && !oldV && this.$refs.textarea) {
        utils.highlight_element(this.$refs.textarea, 2);
      }
    }
  }
};
</script>

<style scoped lang="scss">
$danger: #dc3545;

/* Le composant remplace un .input-group qui occupait toute la largeur de la
   .row parente : on reproduit ce comportement. */
.char-counter-textarea {
  width: 100%;
}

.counter-line {
  font-size: 0.8rem;
  margin-top: 0.15rem;
}

/* Couleurs définies ici plutôt que via les utilitaires Bootstrap : le composant
   est aussi utilisé dans les écrans en Bulma. */
.counter-under {
  color: #6c757d;
}

.counter-over {
  color: $danger;
}

.counter-error {
  margin-left: 0.5rem;
  font-weight: bold;
}

.form-control-counted.over-limit {
  border-color: $danger;
  box-shadow: 0 0 0 0.1rem rgba(220, 53, 69, 0.25);
}
</style>
